"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getProductImageHost = exports.PRODUCT_IMAGE_FALLBACK = void 0;
var _App = require("../App/App.config");
var isBrowser = typeof window !== 'undefined';
var isNextCommerce = !isBrowser ? false : _App.NEXT_COMMERCE_PORTS.includes(window.location.port);
var isAemAuthor = !isBrowser ? false : _App.AEM_AUTHOR_PORTS.includes(window.location.port);
var PRODUCT_IMAGE_FALLBACK = 'https://www.sigmaaldrich.com/assets/images/pdp-no-image/pdp-no-image_w640.png';
exports.PRODUCT_IMAGE_FALLBACK = PRODUCT_IMAGE_FALLBACK;
var getProductImageHost = function getProductImageHost() {
  if (isNextCommerce) {
    return '';
  }
  if (isBrowser && isAemAuthor) {
    if (window.location.hostname.includes(_App.AEM_AUTHOR_HOST.DEV)) {
      return _App.STRATOS_HOST.DEV;
    }
    if (window.location.hostname.includes(_App.AEM_AUTHOR_HOST.QA)) {
      return _App.STRATOS_HOST.QA;
    }
    if (window.location.hostname.includes(_App.AEM_AUTHOR_HOST.PROD)) {
      return _App.STRATOS_HOST.PROD;
    }
  }
  if (isBrowser && (window.location.port === '4000' || window.location.host.includes('local'))) {
    return _App.STRATOS_HOST.DEV;
  }
  return _App.STRATOS_HOST.PROD;
};
exports.getProductImageHost = getProductImageHost;